import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButtonGroup from '../icon-button-group';
import Paragraph from '../paragraph';
import { APPEARANCES } from '../paragraph/constants';

function ColorScheme({
  isDarkTheme = false,
  editTooltipLabel = '',
  deleteTooltipLabel = '',
  resetTooltipLabel = '',
  designTooltipLabel = '',
  onDeleteClick = null,
  onResetClick = null,
  onEditClick,
  title,
  backgroundColor = '',
  onDesignConfigure = null,
}) {
  const classes = classNames('ws-ui-color-scheme', {
    'ws-ui-color-scheme--dark': isDarkTheme,
  });
  const defaultActionProps = {
    appearance: isDarkTheme ? 'dark' : 'light',
    size: 'small',
  };

  const actions = [
    Boolean(onDesignConfigure) && {
      ...defaultActionProps,
      glyph: 'design',
      label: designTooltipLabel,
      onClick: onDesignConfigure,
    },
    Boolean(onResetClick) && {
      ...defaultActionProps,
      glyph: 'reset',
      label: resetTooltipLabel,
      onClick: onResetClick,
    },
    {
      ...defaultActionProps,
      glyph: 'settings',
      label: editTooltipLabel,
      onClick: onEditClick,
    },
    Boolean(onDeleteClick) && {
      ...defaultActionProps,
      glyph: 'trash',
      label: deleteTooltipLabel,
      onClick: onDeleteClick,
    },
  ].filter(Boolean);

  return (
    <div className={classes} onClick={onEditClick} style={{ backgroundColor }}>
      <Paragraph
        size="large"
        appearance={isDarkTheme ? APPEARANCES.white : APPEARANCES.highEmphasis}
      >
        <b>Aa</b>
      </Paragraph>
      <div className="ws-ui-color-scheme__container">
        <Paragraph
          appearance={isDarkTheme ? APPEARANCES.white : APPEARANCES.highEmphasis}
          isClipped
        >
          <b>{title}</b>
        </Paragraph>
        <div className="ws-ui-color-scheme__icon-button-group">
          <IconButtonGroup actions={actions} />
        </div>
      </div>
    </div>
  );
}

ColorScheme.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  onDeleteClick: PropTypes.func,
  onResetClick: PropTypes.func,
  editTooltipLabel: PropTypes.string,
  deleteTooltipLabel: PropTypes.string,
  designTooltipLabel: PropTypes.string,
  resetTooltipLabel: PropTypes.string,
  isDarkTheme: PropTypes.bool,
  onDesignConfigure: PropTypes.func,
};

export default ColorScheme;
